import index from './index.vue';
import { FormResult } from './all.type';

export default index;
export {
    FormResult
};